import { FC, HTMLAttributes, PropsWithChildren, useContext, useEffect, useRef } from "react";
import styled from "styled-components";
import { LibraryContext } from "lib/context/corphurusato/LibraryContext";

type Props = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    color: string;
  }
>;
const Headline: FC<Props> = ({ color, children, ...props }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const { gsap } = useContext(LibraryContext);
  useEffect(() => {
    if (gsap && rootRef.current) {
      const params = {
        scrollTrigger: {
          trigger: rootRef.current,
          start: "top 80%",
          end: "bottom top",
          toggleActions: "play none none none",
          // markers: true,
        },
        x: "0",
        opacity: 1,
        duration: 0.8,
      };
      window.gsap.to(rootRef.current, params);
    }
  }, [gsap]);
  return (
    <Root $color={color} {...props} ref={rootRef}>
      {children}
    </Root>
  );
};
export default Headline;

const Root = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color || "inherit"};
  font-family: sans-serif;
  font-style: italic;
  font-weight: bold;
  vertical-align: text-bottom;
  letter-spacing: 0.1em;
  transform: translateX(-20%);
  opacity: 0;

  @media screen and (max-width: 960px) {
    font-size: 20px;
    margin-bottom: 15px;
  }
  @media screen and (min-width: 961px) {
    font-size: 26px;

    margin-bottom: 30px;
  }
`;

export const Big = styled.em`
  vertical-align: text-bottom;

  @media screen and (max-width: 960px) {
    font-size: 1.428em;
  }
  @media screen and (min-width: 961px) {
    font-size: 1.62em;
  }
`;

export const Sep = styled.span`
  display: inline-block;
  margin-bottom: 5px;
`;
